import styled from "styled-components";

export const Actions = styled.div<{menuDisplayMode: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.menuDisplayMode ? "8px" : "16px"};

  ${props => props.theme.mediaQuerie.maxWidth.md}{
    justify-content: space-between;
    width: 100%;
  }

  .title {
    text-transform: capitalize;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;

  ${props => props.theme.mediaQuerie.maxWidth.md}{
    justify-content: space-between;
    width: 100%;
  }
`;

export const IconContainer = styled.div<{active: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.active ? props.theme.colors.inputBackground : 'transparent'};
  border-radius: 2px;
  padding: 1px;

  transition: all 0.5s;

  &:hover{
    cursor: pointer;
  }

  &:active {
    background-color: ${props => props.theme.colors.border};
  }
`;